// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarMenuItemDropdown(Props) {
  let label = Props.label;
  let list = Props.list;
  let theme = Props.theme;
  let idx = Props.idx;
  const match = React.useState(function () {
    return false;
  });
  const setDropdownShown = match[1];
  const dropdownShown = match[0];
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  const activatorRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  Buhta_landing__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
    Curry._1(setDropdownShown, (function (param) {
      return false;
    }));
  }));
  const onClickedInside = function (ev) {
    ev.stopPropagation();
  };
  const listDisplay = dropdownShown ? "flex" : "hidden";
  const firstLeft = idx === 0 && deviceType === "tablet" ? "-left-40" : "";
  const labelColor = dropdownShown ? "text-primary" : (
      theme === "dark" ? "text-white" : "text-black-landing"
    );
  const passiveArrow = dropdownShown ? "hidden" : "block";
  const activeArrow = dropdownShown ? "block" : "hidden";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("button", {
        ref: activatorRef,
        children: [
          JsxRuntime.jsx("span", {
            children: label,
            className: "paragraph-large cursor-pointer transition-all duration-200 ease-in-out " + labelColor
          }),
          theme === "dark" ? JsxRuntime.jsx("img", {
              className: "" + passiveArrow + " cursor-pointer",
              alt: "cursor pointer",
              src: StaticAsset.src("/static/icons/dropdown-white.svg")
            }) : JsxRuntime.jsx("img", {
              className: "" + passiveArrow + " cursor-pointer",
              src: StaticAsset.src("/static/icons/dropdown-arrow.svg")
            }),
          JsxRuntime.jsx("img", {
            className: "" + activeArrow + " cursor-pointer",
            src: StaticAsset.src("/static/icons/dropdown-arrow-blue.svg")
          })
        ],
        className: "flex h-full items-center",
        onClick: (function (param) {
          Curry._1(setDropdownShown, (function (param) {
            return !dropdownShown;
          }));
        }),
        onMouseEnter: (function (param) {
          Curry._1(setDropdownShown, (function (param) {
            return true;
          }));
        })
      }),
      JsxRuntime.jsxs("div", {
        ref: dropdownRef,
        children: [
          Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(Stdlib__List.sort((function (a, b) {
            return a.order - b.order | 0;
          }), list), (function (idx, s) {
            const route = "/" + countryStr + "/" + languageStr + s.path;
            const icon = s.icon;
            const Key = "list_item_" + String(idx);
            return JsxRuntime.jsxs(Buhta_landing__Link.make, {
              route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(route)),
              className: "w-78 flex mb-6 items-center cursor-pointer group",
              onLinkClicked: (function (param) {
                Curry._1(setDropdownShown, (function (param) {
                  return !dropdownShown;
                }));
              }),
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-14",
                  alt: "buhta",
                  src: icon
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("p", {
                      children: s.title,
                      className: "paragraph-medium text-black-landing group-hover:text-primary transition-all duration-200 ease-in-out"
                    }),
                    JsxRuntime.jsx("p", {
                      children: s.subtitle,
                      className: "paragraph-small text-gray-landing group-hover:text-primary transition-all duration-200 ease-in-out"
                    })
                  ],
                  className: "ml-4 w-60"
                })
              ]
            }, Key);
          }))),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "passive mr-2 transition-all duration-200 ease-in-out",
                    src: StaticAsset.src("/static/icons/tickets.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "active mr-2 transition-all duration-200 ease-in-out",
                    src: StaticAsset.src("/static/icons/tickets-blue.svg")
                  }),
                  Buhta_landing__I18n.trans(intl, "help_center")
                ],
                className: "paragraph-small flex ml-0 text-gray-landing cursor-pointer hover:text-primary navbar-bottom-item"
              }),
              JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "passive mr-2 transition-all duration-200 ease-in-out",
                    src: StaticAsset.src("/static/icons/question.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "active mr-2 transition-all duration-200 ease-in-out w-5",
                    src: StaticAsset.src("/static/icons/question-blue.svg")
                  }),
                  Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta")
                ],
                className: "paragraph-small flex ml-6 first:ml-0 text-gray-landing cursor-pointer hover:text-primary navbar-bottom-item"
              }),
              JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: /* Contact */ 7
                },
                className: "paragraph-small flex ml-6 first:ml-0 text-gray-landing cursor-pointer hover:text-primary navbar-bottom-item",
                onLinkClicked: (function (param) {
                  Curry._1(setDropdownShown, (function (param) {
                    return !dropdownShown;
                  }));
                }),
                children: [
                  JsxRuntime.jsx("img", {
                    className: "passive mr-2 transition-all duration-200 ease-in-out",
                    src: StaticAsset.src("/static/icons/at.svg")
                  }),
                  JsxRuntime.jsx("img", {
                    className: "active mr-2 transition-all duration-200 ease-in-out",
                    src: StaticAsset.src("/static/icons/at-blue.svg")
                  }),
                  Buhta_landing__I18n.trans(intl, "contacts")
                ]
              })
            ],
            className: "flex mt-4"
          })
        ],
        className: "w-182 p-10 justify-between flex-wrap navbar-list absolute bg-white rounded-md shadow-dropdown-landing top-16 " + listDisplay + " z-10 " + firstLeft,
        onMouseLeave: (function (param) {
          Curry._1(setDropdownShown, (function (param) {
            return false;
          }));
        })
      })
    ],
    className: "relative ml-7.75 first:ml-0",
    onClick: onClickedInside,
    onMouseLeave: (function (param) {
      Curry._1(setDropdownShown, (function (param) {
        return false;
      }));
    })
  });
}

const make = NavbarMenuItemDropdown;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
